import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { theme } from '../../../utils/constant'
import logo from '../../../assets/logos/aye-logo.png'
import backgroundImage from '../../../assets/background.jpg'

export default function RegistrationScreenSuccess() {
  const navigate = useNavigate()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/login')
    }, 5000)

    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}>
      <div className="mt-4 flex w-full flex-col items-center justify-center">
        <img src={logo} alt="Aye Logo" width={'7%'} height={'100%'} />
        <img
          className="mt-10 w-[14%] object-contain"
          src={require('../../../assets/gate_open.png')}
          alt="Gate Open"
        />
      </div>
      <div className="mt-8 flex flex-col items-center justify-center gap-8">
        <div className="flex flex-col items-center justify-center gap-8">
          <p
            className="text-center font-bold text-[#333333]"
            style={{ fontSize: theme.textSize.values.title1 }}>
            Registration successful!
          </p>
          <p
            className="mt-2 text-center"
            style={{ fontSize: theme.textSize.values.subTitle }}>
            You can now pay with just your face at any
            <br />
            outlet with Aye Face
          </p>
        </div>
        <div className="flex items-center justify-center">
          <div className="mt-3 text-center">
            <p
              className="mt-3 text-center"
              style={{ fontSize: theme.textSize.values.subTitle }}>
              To manage your payments, please go to
            </p>
            <button
              className="text-center text-[#237ABE] underline"
              style={{ fontSize: theme.textSize.values.subTitle }}
              onClick={() =>
                (window.location.href = 'https://dev.aye-login.com/portal')
              }>
              dev.aye-login.com/portal
            </button>
          </div>
        </div>
      </div>
      <button
        onClick={() =>
          window.open('https://paynet.my/about-paynet.html', '_blank')
        }
        className="mt-8">
        Authorised by <span className="font-bold text-blue-600">Pay</span>
        <span className="font-bold text-green-600">Net</span>
      </button>
    </div>
  )
}
